import React, { useState, useEffect } from 'react';
import InvestmentServices from "../../services/InvestmentService";
import InventoryServices from "../../services/InventoryServices";
import CottageServices from "../../services/CottageServices";

function UpdateProperty({ user, closeModal, onSuccess }) {
    const [cottage, setCottage] = useState([]);
    const [room, setRooms] = useState([]);
    const [formValues, setFormValues] = useState({
        property: "",
        room:"",
        bookingPercentage:"",
        investor: user?.id,
        purchaseDate: "",
        investmentPrice: "",
        paymentmethod: "",
    });

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            return ''; // Return an empty string for invalid dates
        }
        const year = date.getFullYear().toString();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };
    useEffect(() => {
        const fetchCottage = async () => {
            try {
                const res = await CottageServices.getCottage();
                if (res.status) {
                    setCottage(res.data);
                } else {
                    alert('Failed to fetch Cottage');
                }
            } catch (error) {
                console.error('Error fetching Cottage', error);
                alert('Failed to fetch Cottage');
            }
        };
        fetchCottage();
    }, []);
    useEffect(() => {
        const fetchRoom = async () => {
          if (formValues.property) {
            try {
              const response = await InventoryServices.getInventoryByCottage(formValues.property);
              setRooms(response.data);
            } catch (error) {
              console.error('Failed to fetch rooms', error);
            }
          }
        };
        fetchRoom();
      }, [formValues.property]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            await InvestmentServices.createInvestment(formValues);
            alert('Investment updated successfully');
            onSuccess();
            closeModal();
        } catch (error) {
            console.error('Failed to update Investment', error);
            alert(error.response?.data?.message || 'Failed to update Investment');
        }
    };

    return (
        <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Property Investment</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
                    </div>
                    <div className="modal-body">
                        <div className="container-box px-5">
                            <div className="container-box-inner">
                                <div className="page-details">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field">
                                                    <label>Property to Invest In</label>
                                                    <select className="form-select" name="property" value={formValues.property} onChange={handleInputChange}>
                                                        <option value="">Select  property name</option>
                                                        {cottage.map((property) => (
                                                            <option key={property?._id} value={property?._id}>
                                                                {property.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field">
                                                    <label>Room Number</label>
                                                    <select className="form-select" name="room" value={formValues.room} onChange={handleInputChange}>
                                                        <option value="">Select  Room Number</option>
                                                        {room.map((inventory) => (
                                                            <option key={inventory?._id} value={inventory?._id}>
                                                                {inventory.roomNumber}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field">
                                                    <label>Investment Amount</label>
                                                    <input
                                                        type="number"
                                                        name="investmentPrice"
                                                        className="form-control"
                                                        value={formValues.investmentPrice}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter Investment Amount"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field">
                                                    <label>Booking Percentage</label>
                                                    <input
                                                        type="number"
                                                        name="bookingPercentage"
                                                        className="form-control"
                                                        value={formValues.bookingPercentage}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter Booking Percentage"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field">
                                                    <label>Payment method</label>
                                                    <select
                                                        type="text"
                                                        name="paymentmethod"
                                                        className="form-control"
                                                        value={formValues.paymentmethod}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter Investment Amount"
                                                        required
                                                    >
                                                        <option value="">--Select Type--</option>
                                                        <option value="Credit Card">Credit Card</option>
                                                        <option value="Debit Card">Debit Card</option>
                                                        <option value="Net Banking">Net Banking</option>
                                                        <option value="UPI">UPI</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field">
                                                    <label>Investment Date</label>
                                                    <input
                                                        type="date"
                                                        name="purchaseDate"
                                                        className="form-control"
                                                        value={formValues.purchaseDate}
                                                        onChange={handleInputChange}
                                                        placeholder="investmentDate"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <button className="site-btn-green" type="submit">
                                            Save
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UpdateProperty;
